module.exports = __webpack_public_path__ + "static/media/phone-profile.47e19456.svg";